import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import fetchWrapper from '../utils/httpClient';
import { API_CREATE_USER, API_GET_ROLE_ID } from '../utils/apis';

export const fetchRoles = createAsyncThunk('createUser/fetchRoles', async () => {
  try {
    const response = await fetchWrapper.get(API_GET_ROLE_ID);
    return response.resdata;
  } catch (error) {
    throw new Error(error.message);
  }
});

export const registerUser = createAsyncThunk('createUser/register', async (payload, { rejectWithValue }) => {
  try {
    const response = await fetchWrapper.post(API_CREATE_USER, payload);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const createUserSlice = createSlice({
  name: 'createUser',
  initialState: {
    user: null,
    loading: false,
    error: null,
    roles: [],
    status: null
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "pending";
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.resdata;
        state.status = "succeeded";
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
        state.status = "failed";
      })

      .addCase(fetchRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "pending";
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.status = "failed";
      });
  }
});

export default createUserSlice.reducer;